import { render, staticRenderFns } from "./CreatePayPalAccount.vue?vue&type=template&id=ad3a0756&"
import script from "./CreatePayPalAccount.vue?vue&type=script&lang=js&"
export * from "./CreatePayPalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports